import { Routes, RouterModule } from '@angular/router';
import { ConsultarHistoricoComponent } from './consultar-historicos.component';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';
import { NgModule } from '@angular/core';

const routes: Routes = [
    { path: '', component: ConsultarHistoricoComponent },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  
  export class ConsultarHistoricoRouting { }